import React from 'react';
import CardFeature from './CardFeature';

import cafImg from '../assets/caf.png';
import immigrazioneImg from '../assets/immigrazione.png';
import serviziImg from '../assets/servizi.png';

const About = () => {
  const cardData = [
    {
      image: cafImg,
      title: 'CAF',
      description:
        'Fornisce servizi fiscali come dichiarazioni dei redditi, ISEE e prestazioni familiari.',
    },
    {
      image: immigrazioneImg,
      title: 'IMMIGRAZIONE',
      description:
        'Assiste con permessi di soggiorno, cittadinanza, ricongiungimenti familiari e supporto agli immigrati.',
    },
    {
      image: serviziImg,
      title: 'ALTRI SERVIZI',
      description:
        'Copre servizi aggiuntivi come assistenza abitativa, bonus e certificazioni.',
    },
  ];

  return (
    <section className="relative py-12 px-6">
      <h2 className="text-3xl font-bold text-center text-slate-800 mb-12 underline decoration-yellow-400 decoration-4 underline-offset-8">
        SIAMO QUI PER SUPPORTARTI
      </h2>
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12">
        {cardData.map((card, index) => (
          <CardFeature
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
};

export default About;
